'use strict'

import Swal from 'sweetalert2'
import '../vendor/jquery.highlight'

var Cookies = require('js-cookie')

export default class Shared {
  static setKeywordsHighlight(keywords) {
    if (keywords != '') {
      let keyword_copy = ''
      let count        = 0

      for (let i = 0; i < keywords.length; i++) {
        keyword_copy += keywords[i]
        if (keywords[i] === '"') {
          if (count % 2 === 0) keyword_copy += '*'
          count += 1
        }
      }

      let highlightArray = []

      keyword_copy.split('"').forEach((item) => {
        if (!item) return true

        if (item.includes('*')) {
          item = item.slice(1)
          highlightArray.push(item)
          return true
        }

        highlightArray = highlightArray.concat(item.split(' '))
      })

      $('.highlight_section').highlight(highlightArray)
    }
  }

  static setToShowDialogCheckClear(show_dialog_flg) {
    if (show_dialog_flg) {
      // '1 / 24 / 60 / 6' means 10 seconds
      Cookies.set('show-dialog-check-clear', true, { expires: 1 / 24 / 60 / 6 });
    }
    if (this._isParentWindowSelf(window) && (!gon.is_reload_parent_tab)) {
      window.opener.location.reload(true);
      if (this._isParentWindowSelf(window.opener)) {
        // Reload search/company_applicants page when sent message
        window.opener.opener.location.reload(true);
      }
    }
  }

  static showDialogCheckClear(title_str, content_str) {
    if (Cookies.get('show-dialog-check-clear') == "true") {
      Swal.fire(title_str, content_str);
      Cookies.remove('show-dialog-check-clear');
    }
  }

  static daijobOpenWindow(url,name,width,height) {
    const features = 'height=' + height + ',width=' + width + ',scrollbars=yes,resizable=yes,toolbar=yes,menubar=yes,location=yes';
    const w = window.open(url,name,features);
    if (w) {
      w.focus();
      return false; // so normal href link does not run
    } else {
      return true;
    }
  }

  static selfDestruct() {
    if (window.opener !== null && gon.is_reload_parent_tab == null) {
      window.opener.location.reload(true);
    }
    window.close();
  }

  static reloadParentTab() {
    // Check reload parent tag now?
    if (window.opener !== null && gon.is_reload_parent_tab == true) {
      window.opener.location.reload(true);
    }
  }

  static checkAllCheckboxes(form, value) {
    var check_boxes = form.querySelectorAll("[type='checkbox']:not([name='is_active'])");
    check_boxes.forEach(function (check_box) {
      check_box.checked = value;
    })
  }

  static MM_openBrWindow(theURL,winName = '',features = 'menubar=no,scrollbars=no,resizable=yes,width=650,height=930') {
    var w = window.open(theURL,winName,features);
    if (w) {
      w.focus();
    }
  }

  static transferCheckboxes( job_name ) {
    // get and init data
    let checked_job = self.opener.document.getElementById(job_name);
    let list_job = document.getElementById(job_name);
    let hidden_field_job = '';
    if (checked_job && list_job) {
      let check_box_job = list_job.getElementsByTagName('input');
      if (check_box_job) {
        // create hidden field for checked job
        for (let i = 0; i < check_box_job.length; i++ ) {
          let input = check_box_job[i];
          if (input && (input.type == 'checkbox') && (input.checked)) {
            hidden_field_job += `<input type="hidden" name="${job_name}[]" value="${input.value}" />&nbsp;${input.getAttribute('alt')}<br />`;
          }
        }
      }
      checked_job.innerHTML = hidden_field_job;
    }
    window.close();
    return false;
  }

  static goBack() {
    window.history.back();
  }

  static _isParentWindowSelf(popup) {
    return popup.opener && popup.location.href !== popup.opener.location.href
  }

  static initializeMatchLevels(){
    $('.recommend-level').on('inview', function(_, isInView){
      if(isInView) $(this).addClass('-animated');
    });
  }
}
